/**
* @description: 上机/落机打卡记录
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    <el-button
                        type="primary"
                        icon="Plus"
                        @click="manualOtRecord?.open()"
                    >{{ t('attendance.manualRecord') }}</el-button>
                    <el-button
                        type="success"
                        icon="Download"
                        @click="exportData()"
                        >{{ t('attendance.export') }}</el-button
                    >
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['detail'].open(scope.row)">{{ t('common.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>

        <Detail ref="detail" />
        <ManualOtRecord ref="manualOtRecord" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw } from "vue";
import { ElMessage } from "element-plus";
import Detail from "./components/record-detail.vue";
import ManualOtRecord from "./components/manual-ot-record.vue";
import { useAttendancePageI18n, t } from '@/composables/useAttendancePageI18n.js';

import { exportExcel } from "@/utils/apiBase"
import { pageListApi } from "@/api/attendance/OTDR.js";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { listToMap } from "@/utils/utils";
const myElementRef = ref();
const searchBox = ref();
const detail = ref();
const manualOtRecord = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const buildSourceMap = () => ([
    { label: t('attendance.ot'), value: 1 },
    { label: t('attendance.zhongzhi'), value: 2 }
]);

const buildLxOptions = () => ([
    { label: t('common.all'), value: 99 },
    { label: t('attendance.ot'), value: 1 },
    { label: t('attendance.zhongzhi'), value: 2 }
]);

const sourceMap = reactive(buildSourceMap());
const lxOptions = ref(buildLxOptions());

const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0
    })
    userListApi(params).then(res => {
        searchData[0].children = res.data.map(i => {
            return { label: i.real_name, value: i.real_name }
        })
        getSearch(searchData)
    })
}

const searchData = reactive([
    { label: "", type: "select", value: "", field: 'keywords', children: [] },
    { label: "", type: "daterange", value: [], field: 'time', seditem: '', enditem: '' },
    { label: "", type: "select", value: "", field: 'lx', children: lxOptions }
]);

const buildColumns = () => ([
    { prop: "id", show: false, label: "ID" },
    { show: true, type: "index", label: t('table.index'), width: 80 },
    { prop: "real_name", show: true, label: t('field.realName') },
    { prop: "mobile", show: true, label: t('field.mobile') },
    { prop: "checkin_time", show: true, label: t('detail.clockTime') },
    { prop: "source", show: true, label: t('attendance.clockType') },
    { prop: "overtime", show: true, label: t('attendance.overtimeTime') },
    { prop: "overtime_market", show: true, label: t('attendance.overtimeDuration') },
    { prop: "contents", show: true, label: t('attendance.workContent') },
    { prop: "address", show: true, label: t('attendance.location') },
    { prop: "operation", show: true, label: t('table.operation') },
]);

const applyLabels = () => {
    searchData[0].label = t('field.realName');
    searchData[1].label = t('common.startTime');
    searchData[2].label = t('attendance.clockType');
    lxOptions.value = buildLxOptions();
    searchData[2].children = lxOptions;
    Object.assign(sourceMap, buildSourceMap());
    state.column = buildColumns();
    tableHeaderFn();
};

useAttendancePageI18n(applyLabels);

const state = reactive({
	loading: false,
    title: "",
    column: buildColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: []
});

const init = () => {
    getUserList()
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

const exportData = async () => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    if (timeData[0] == undefined || timeData[1] == undefined) {
        ElMessage.warning(t('attendance.selectTimeRange'))
        return
    }
    const params = {
        stime: timeData[0],
        etime: timeData[1],
    }
    const keywords = searchData.find((i) => i.field === 'keywords')?.value ?? ''
    if (keywords) {
        params.keywords = keywords
    }
    const lx = searchData.find((i) => i.field === 'lx')?.value
    if (lx !== '' && lx != null) {
        params.lx = lx
    }
    const { ok, msg } = await exportExcel('Excel/insertJIAccountExcel', params, 'OT中直.xls')
    if (!ok) {
        ElMessage.error(msg || t('attendance.exportFailed'))
    }
}

onMounted(() => {
    try {
        applyLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

const getSearch = (params) => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    const requestParams = JSON.stringify({
        "keywords": searchData[0].value ?? '',
        "stime": timeData[0] ?? '',
        "etime": timeData[1] ?? '',
        "page": page.value,
        "limit": limit.value,
        "lx": searchData[2].value
    })
    state.loading = true

    pageListApi(requestParams).then(res => {
        maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data?.map(item => {
        return {
         ...item,
          source: listToMap(sourceMap, {})[item.source],
          overtime_market: `${item.overtime_market}${t('detail.unitHour')}`,
        }
      })
    }).finally(() => {
    state.loading = false
  })
};

const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
